import { Navigate, Outlet } from "react-router-dom";

const RoleRoute = ({ allowedRoles }) => {
  const adminUser = JSON.parse(localStorage.getItem("adminUser"));

  if (!adminUser) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!allowedRoles.includes(adminUser.role)) {
    return <Navigate to="/admin/blogs" replace />;
  }

  return <Outlet />;
};

export default RoleRoute;